document.addEventListener('DOMContentLoaded', () => {
  const sortButtonMobile = document.querySelector('.sort-button-mobile');
  const sortButtonMobileSticky = document.querySelector('.sort-button-mobile-sticky');
  const sortButtonDesktop = document.querySelector('.sort-button-desktop');
  const sortDrawers = document.querySelectorAll('.sort-drawer');
  const sortDrawerBackdrops = document.querySelectorAll('.sort-drawer-backdrop');
  const sortDrawerContents = document.querySelectorAll('.sort-drawer-content');
  const sortDrawerCloses = document.querySelectorAll('.sort-drawer-close');
  const sortOptionButtons = document.querySelectorAll('.sort-option-button');

  const sortButtonIconSelector = '.sort-button-icon';
  const sortButtonSelector = '.sort-button-mobile, .sort-button-mobile-sticky, .sort-button-desktop';

  const sortDrawer = sortDrawers[0];
  const sortDrawerBackdrop = sortDrawerBackdrops[0];
  const sortDrawerContent = sortDrawerContents[0];

  if (!sortDrawer || !sortDrawerBackdrop || !sortDrawerContent) return;

  const allSortButtons = document.querySelectorAll(sortButtonSelector);
  const sortIndicatorIcons = document.querySelectorAll('.sort-indicator-icon');
  let selectedSortValue = null;

  let closeSortDrawerTimeoutId = null;

  function openSortDrawer() {
    if (closeSortDrawerTimeoutId !== null) {
      clearTimeout(closeSortDrawerTimeoutId);
      closeSortDrawerTimeoutId = null;
    }

    requestAnimationFrame(() => {
      if (document.body.dataset.scrollY === undefined) {
        const scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';
        document.body.classList.add('overflow-hidden');
        document.body.dataset.scrollY = scrollY;
      }

      sortDrawers.forEach(drawer => drawer.classList.remove('pointer-events-none'));
      sortDrawerBackdrops.forEach(backdrop => {
        backdrop.classList.remove('opacity-0');
        backdrop.classList.add('opacity-100');
      });
      sortDrawerContents.forEach(content => {
        content.classList.remove('invisible', 'translate-y-full', 'lg:translate-x-full');
        content.classList.add('translate-y-0', 'lg:translate-x-0');
      });

      allSortButtons.forEach(btn => {
        btn.setAttribute('aria-expanded', 'true');
        const icon = btn.querySelector(sortButtonIconSelector);
        if (icon) icon.classList.add('rotate-45');
      });

      const urlParams = new URLSearchParams(window.location.search);
      selectedSortValue = urlParams.get('sort_by') || 'manual';
      updateActiveSortState();
    });
  }

  function closeSortDrawer() {
    requestAnimationFrame(() => {
      sortDrawerBackdrops.forEach(backdrop => {
        backdrop.classList.remove('opacity-100');
        backdrop.classList.add('opacity-0');
      });
      sortDrawerContents.forEach(content => {
        content.classList.remove('translate-y-0', 'lg:translate-x-0');
        content.classList.add('translate-y-full', 'lg:translate-x-full');
      });

      closeSortDrawerTimeoutId = setTimeout(() => {
        closeSortDrawerTimeoutId = null;
        sortDrawers.forEach(drawer => drawer.classList.add('pointer-events-none'));
        sortDrawerContents.forEach(content => content.classList.add('invisible'));

        const scrollY = document.body.dataset.scrollY;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.classList.remove('overflow-hidden');

        if (scrollY) {
          window.scrollTo(0, parseInt(scrollY, 10));
          delete document.body.dataset.scrollY;
        }
      }, 300);

      allSortButtons.forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
        const icon = btn.querySelector(sortButtonIconSelector);
        if (icon) icon.classList.remove('rotate-45');
      });

      const urlParams = new URLSearchParams(window.location.search);
      selectedSortValue = urlParams.get('sort_by') || 'manual';
      updateActiveSortState();
    });
  }

  function updateActiveSortState() {
    const sortValueToHighlight = selectedSortValue || (() => {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('sort_by') || 'manual';
    })();

    const buttonsToUpdate = [];
    sortOptionButtons.forEach(btn => {
      buttonsToUpdate.push({
        element: btn,
        value: btn.getAttribute('data-sort-value'),
        isActive: btn.getAttribute('data-sort-value') === sortValueToHighlight
      });
    });

    requestAnimationFrame(() => {
      buttonsToUpdate.forEach(({ element, isActive }) => {
        const radioButton = element.querySelector('.sort-option-radio');
        const checkIcon = element.querySelector('.sort-option-check');

        if (isActive) {
          if (radioButton) {
            radioButton.classList.remove('border-gray-300');
            radioButton.classList.add('border-black', 'bg-black');
          }
          if (checkIcon) {
            checkIcon.classList.remove('hidden');
          }
        } else {
          if (radioButton) {
            radioButton.classList.remove('border-black', 'bg-black');
            radioButton.classList.add('border-gray-300');
          }
          if (checkIcon) {
            checkIcon.classList.add('hidden');
          }
        }
      });
    });

    const urlParams = new URLSearchParams(window.location.search);
    const appliedSort = urlParams.get('sort_by') || 'manual';
    updateSortIndicator(appliedSort);
  }

  function initializeSortFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const appliedSort = urlParams.get('sort_by') || 'manual';
    selectedSortValue = appliedSort;
    updateActiveSortState();
    updateSortIndicator(appliedSort);
  }

  initializeSortFromURL();

  function updateSortIndicator(currentSort) {
    const isSortApplied = currentSort && currentSort !== 'manual';

    requestAnimationFrame(() => {
      sortIndicatorIcons.forEach(icon => {
        if (isSortApplied) {
          icon.classList.remove('hidden');
        } else {
          icon.classList.add('hidden');
        }
      });
    });
  }

  if (sortButtonMobile) {
    sortButtonMobile.addEventListener('click', (e) => {
      e.stopPropagation();
      openSortDrawer();
    });
  }

  if (sortButtonMobileSticky) {
    sortButtonMobileSticky.addEventListener('click', (e) => {
      e.stopPropagation();
      openSortDrawer();
    });
  }

  if (sortButtonDesktop) {
    sortButtonDesktop.addEventListener('click', (e) => {
      e.stopPropagation();
      openSortDrawer();
    });
  }

  sortDrawerCloses.forEach(closeBtn => {
    closeBtn.addEventListener('click', closeSortDrawer);
  });

  sortDrawerBackdrops.forEach(backdrop => {
    backdrop.addEventListener('click', closeSortDrawer);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && sortDrawer && !sortDrawer.classList.contains('pointer-events-none')) {
      closeSortDrawer();
    }
  });

  updateActiveSortState();

  sortOptionButtons.forEach(button => {
    button.addEventListener('click', function (e) {
      e.stopPropagation();
      e.preventDefault();

      const sortValue = this.getAttribute('data-sort-value');
      if (!sortValue) return;

      selectedSortValue = sortValue;
      updateActiveSortState();
    });
  });

  async function applySort(sortValue) {
    if (!sortValue) return;

    closeSortDrawer();

    const allGrids = document.querySelectorAll('.collection-product-grid[data-collection-handle]');
    if (allGrids.length === 0) return;

    const sortCurrentUrl = new URL(window.location.href);
    const activeCollectionHandle = sortCurrentUrl.searchParams.get('tab') || 'all';

    const originalContents = new Map();
    requestAnimationFrame(() => {
      allGrids.forEach(grid => {
        originalContents.set(grid, grid.innerHTML);
        grid.classList.add('opacity-50', 'pointer-events-none');
      });
    });

    const sectionId = 'collection-product-grid';
    const sortPromises = Array.from(allGrids).map(async (grid) => {
      const collectionHandle = grid.getAttribute('data-collection-handle');
      if (!collectionHandle) return;

      try {
        const gridCurrentUrl = new URL(window.location.href);
        const subCollectionUrl = new URL(`/collections/${collectionHandle}`, window.location.origin);
        subCollectionUrl.searchParams.set('sort_by', sortValue);
        subCollectionUrl.searchParams.set('sections', sectionId);

        gridCurrentUrl.searchParams.forEach((value, key) => {
          if (key.startsWith('filter.')) {
            subCollectionUrl.searchParams.append(key, value);
          }
        });

        const response = await fetch(subCollectionUrl.toString());

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        const sectionHtml = data[sectionId] || '';

        if (!sectionHtml) {
          throw new Error('No section data returned');
        }

        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionHtml, 'text/html');
        const newGrid = doc.querySelector(
          `.collection-product-grid[data-collection-handle="${collectionHandle}"]`
        );

        if (newGrid) {
          requestAnimationFrame(() => {
            grid.setAttribute(
              'data-has-products',
              newGrid.getAttribute('data-has-products') || 'false'
            );
            grid.innerHTML = newGrid.innerHTML;
            if (typeof window.initializeProductCardVariants === 'function') {
              window.initializeProductCardVariants(grid);
            }
          });
        } else {
          throw new Error('Grid not found in response');
        }
      } catch (error) {
        console.error(`Error sorting collection ${collectionHandle}:`, error);
        const originalContent = originalContents.get(grid);
        if (originalContent) {
          requestAnimationFrame(() => {
            grid.innerHTML = originalContent;
            if (typeof window.initializeProductCardVariants === 'function') {
              window.initializeProductCardVariants(grid);
            }
          });
        }
      }
    });

    try {
      await Promise.all(sortPromises);

      requestAnimationFrame(() => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortValue);

        if (activeCollectionHandle && activeCollectionHandle !== 'all') {
          url.searchParams.set('tab', activeCollectionHandle);
        } else {
          url.searchParams.delete('tab');
        }

        window.history.pushState({}, '', url.toString());

        allGrids.forEach(grid => {
          grid.classList.remove('opacity-50', 'pointer-events-none');
        });

        if (typeof window.initializeProductCardVariants === 'function') {
          allGrids.forEach(grid => {
            window.initializeProductCardVariants(grid);
          });
        }

        updateActiveSortState();

        if (typeof window.setActiveTabFromURL === 'function') {
          window.setActiveTabFromURL();
        }
      });
    } catch (error) {
      console.error('Error sorting collections:', error);
      requestAnimationFrame(() => {
        allGrids.forEach(grid => {
          grid.classList.remove('opacity-50', 'pointer-events-none');
        });
      });
    }
  }

  function clearSort() {
    applySort('manual');
  }

  const applyButtons = document.querySelectorAll('.sort-apply-button');
  applyButtons.forEach(applyButton => {
    applyButton.addEventListener('click', (e) => {
      e.stopPropagation();
      if (selectedSortValue) {
        applySort(selectedSortValue);
      }
    });
  });

  const clearButtons = document.querySelectorAll('.sort-clear-button');
  clearButtons.forEach(clearButton => {
    clearButton.addEventListener('click', (e) => {
      e.stopPropagation();
      clearSort();
    });
  });
});
